import { CursorPaginatedResponseSchema, DefaultCursorPageSchema } from 'notable-common';
import { z } from 'zod';
/**
 * The filters and page the practice list accepts.
 *
 * No `sort`: results come back ordered by name.
 */
export const PracticeListQuerySchema = z
    .object({
    q: z
        .string()
        .min(1)
        .max(200)
        .optional()
        .describe('Return only practices whose name contains this text, case-insensitively.'),
    // An empty array would serialize to no parameter at all, and so ask for every practice.
    ids: z
        .union([z.uuid(), z.array(z.uuid()).min(1).max(100)])
        .optional()
        .describe('Return only these practices, for example to name the practice an id refers to.'),
    organizationIds: z
        .union([z.uuid(), z.array(z.uuid()).min(1).max(50)])
        .optional()
        .describe('Return only practices of these organizations.'),
    page: DefaultCursorPageSchema,
})
    .strict();
export const PracticeListEntrySchema = z.object({
    id: z.uuid(),
    name: z.string(),
    organizationId: z.uuid().describe('The organization the practice belongs to.'),
});
/** One page of practices ordered by name, in the envelope every cursor-paginated route returns. */
export const PracticeListResponseSchema = CursorPaginatedResponseSchema(PracticeListEntrySchema);
//# sourceMappingURL=list.js.map